function renderHTML(element, _a) {
  var style = _a.style,
    vars = _a.vars;
  // Directly assign style into the Element's style prop. In tests Object.assign is the
  // fastest way to assign styles.
  Object.assign(element.style, style);
  // Loop over any CSS variables and assign those.
  for (var key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}
export { renderHTML };